<div class="container-fluid">

    <h4 id="upper"> Utilisateurs connectés </h4>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div>
                        <!--  -->
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                            <label for="categorie" class="form-label">Rechercher</label>
                            <div>
                                <label class="d-inline-flex align-items-center">
                                    <input title="Rechercher par nom, prénom, email ou téléphone" type="text"
                                        [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control"
                                        id="searchMembre" placeholder="" />

                                </label>
                            </div>

                            <!-- <a (click)="openModal()" title="Cliquez ici pour ajouter un certificat de decès"
                                style="background-color:#578D63 ;" href="javascript:void(0);"
                                class="btn btn-success mb-2" id="gras">
                                <i class="mdi mdi-plus me-2"></i> Ajouter
                            </a>&nbsp; -->
                        </div>


                    </div>
                    <div class="row mb-md-2">


                        <!-- End search -->
                    </div>
                    <div class="table-responsive">
                        <table class="table text-nowrap align-middle mb-0">
                            <thead>
                                <tr class="border-bottom">
                                    <th>Email</th>
                                    <th class="text-center">Statut</th>
                                    <th class="text-center">Date et heure de connexion</th>
                                    <th class="text-center">IP</th>
                                    <th class="text-center">Raison</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of paginatedItems">
                                    <td>{{ item?.email_attempted }}</td>

                                    <td class="text-center">
                                        {{ item?.success ? 'Connexion réussie' : 'Échec' }}
                                    </td>

                                    <td class="text-center">
                                        {{ item?.login_time | date:'dd/MM/yyyy HH:mm' }}
                                    </td>

                                    <td class="text-center">
                                        {{ item?.ip_address }}
                                    </td>

                                    <td class="text-center">
                                        {{ item?.reason }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
                <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Chargement en cours...</h5>
                                <div class="loader4"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                            </div>
                        </div>
                    </div>

                </div>
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
            </div>
        </div>
    </div>


</div>




<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>